fragment LookupCorporateAccountFields on LookupCorporateAccount {
  __typename
  id
  chartOfAccountId
  account
  lookupAccount
  lookupName
  subAccount
  departmentGroupId
  departmentGroup {
    name
  }
  isTravelAccountForAllDepartments
  travelAccountTypeId
  travelAccountType {
    accountType
  }
  _isDeletable
  _isUpdatable
  _rowTimestamp
}
